
import ConfigPage from '../../page/helpers/ConfigPage';
import { EVENTS } from '../../shared/Events';
import ConfigScene from './ConfigScene';

class MnAssetLoader {
  constructor() {
    // vars
    this.pkgDataPrefix = '';
    this.pixiLoader = null;

    // data
    this.dataLoadPool = [];
    this.actualData = null;
  }

  // --------------------------------------------------------------
  // Main
  // --------------------------------------------------------------

  loadMainAssets() {
    // set vars
    this.pkgDataPrefix = aPage.pathPrefix + ConfigPage.PKG_DATA;

    // start with data
    this.loadMainData();
  }

  assetsLoaded() {
    aScene.signals.sceneCallMain.dispatch(EVENTS.SCENE_ASSETS_LOADED);
  }

  // --------------------------------------------------------------
  // Data
  // --------------------------------------------------------------

  loadMainData() {
    this.dataLoadPool = [
      ['heaven', `${this.pkgDataPrefix}data/heaven.json`],
      ['transition', `${this.pkgDataPrefix}data/transition.json`],
      ['town', `${this.pkgDataPrefix}data/town.json`],
      ['activities-info', `${this.pkgDataPrefix}data/activities-info.json`],
    ];
    this.addDaysData();

    this.tryLoadNextData();
  }

  tryLoadNextData() {
    if (this.dataLoadPool.length > 0) {
      this.actualData = this.dataLoadPool.pop();
      $.get(this.actualData[1])
        .done((data) => {
          aScene.dataPool[this.actualData[0]] = data;
          this.tryLoadNextData();
        })
        .fail((jqxhr, settings, exception) => {
          console.log('Data file load error', exception);
        });
    } else {
      this.dataLoaded();
    }
  }

  addDaysData() {
    for (let i = 0; i < actionUuids.length; i += 1) {
      this.dataLoadPool.push([
        `day-${i}`, `${this.pkgDataPrefix}data/days/${i + 1}-${actionUuids[i]}.json`,
      ]);
    }
  }

  dataLoaded() {
    aPage.signals.mainCall.dispatch(EVENTS.SCENE_ASSETS_LOAD_UPDATE, 0.2);
    // continue with images
    this.loadMainImages();
  }

  // --------------------------------------------------------------
  // Images
  // --------------------------------------------------------------

  loadMainImages() {
    this.pixiLoader = PIXI.loader;
    // sheets
    this.pixiLoader.add('st-main', `${this.pkgDataPrefix}img/main/st-main.json`);
    this.pixiLoader.add('st-angels', `${this.pkgDataPrefix}img/main/st-angels.json`);
    this.pixiLoader.add('st-gui', `${this.pkgDataPrefix}img/main/st-gui.json`);

    // images
    this.addLoadImage('lr-bg-0', `${this.pkgDataPrefix}img/main/layers/lr-bg-0.jpg`);
    this.addLoadImage('lr-bg-1', `${this.pkgDataPrefix}img/main/layers/lr-bg-1.jpg`);

    ConfigScene.TOWN_LAYERS.forEach((townLr) => {
      townLr.forEach((townBm) => {
        this.addLoadImage(townBm.bm, `${this.pkgDataPrefix}img/main/layers/${townBm.bm}.png`);
      });
    });

    ConfigScene.TOWN_SNOW_OVER.forEach((snowLr) => {
      snowLr.forEach((snowBm) => {
        this.addLoadImage(snowBm.bm, `${this.pkgDataPrefix}img/main/layers/${snowBm.bm}.png`);
      });
    });

    // listeners
    this.pixiLoader.onProgress.add(() => {
      aPage.signals.mainCall.dispatch(
        EVENTS.SCENE_ASSETS_LOAD_UPDATE,
        Math.min(0.2 + ((this.pixiLoader.progress / 100) * 0.8), 1),
      );
    });
    this.pixiLoader.onComplete.add(() => {
      this.imagesLoaded();
    });

    // start loading
    this.pixiLoader.load();
  }

  addLoadImage(imgId, imgUrl) {
    // save to pool
    aScene.imgPool[imgId] = imgUrl;
    // add to loader
    this.pixiLoader.add(imgId, imgUrl);
  }

  imagesLoaded() {
    // complete event
    aScene.assetLoader.assetsLoaded();
  }
}

export default MnAssetLoader;



// WEBPACK FOOTER //
// ./src/js/scene/helpers/MnAssetLoader.js